import './modernizr'; // adds .no-touchevents class to the body if touch events are not supported, used in eheader.scss
import mainHeader from './header';
import eToroMenu from './menu';
import shadowsOnScroll from './shadows-on-scroll';

// for testing purposes
const etoroTracking = window.etoroTracking || {
    track_link: function() {}
};

mainHeader(etoroTracking);

eToroMenu();

shadowsOnScroll(".shadows-on-scroll");

